import { render } from "./FeatherWrapper.vue?vue&type=template&id=7c0f27d5"
import script from "./FeatherWrapper.vue?vue&type=script&lang=js"
export * from "./FeatherWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__